import React from 'react';
import '../../../assets/css/common/video/test.css';
import SubHeaderComponent from '../../../components/header/subheader';
import {localParam} from '../../../assets/js/utils/util.js';
import config from '../../../assets/js/conf/config.js';
import {request, fnTokenError} from '../../../assets/js/libs/request.js';
import Swiper from "../../../assets/js/libs/swiper.min.js";	//轮播
import { Modal, Toast } from 'antd-mobile';


export default  class VideoTest extends React.Component {
	constructor(props){
		super(props)
		let state = '';
		let testPaperIdArr = null;
		let testPaperId = '';
		if(props.location.state && props.location.state.testPaperId){
			state = props.location.state.testPaperId;
			testPaperIdArr = state.split('?');
			testPaperId = testPaperIdArr[1].split('=');
		}
		this.state = {
			testPaperId: testPaperId[1],
			TestData: [],
			TestData2: null,
			letterArr: ['A','B','C','D','E','F','G'],
			index: 0,
			zongFen: 0,
			subFlag: false,
			score: 0,
			scoreFlag: false,
			sHead: localStorage['LoginData'] !== undefined?JSON.parse(localStorage['LoginData']).photo:require("../../../assets/images/user/my/default-head.png"),
            sNickname: localStorage['LoginData'] !== undefined?JSON.parse(localStorage['LoginData']).accName:"路人甲",
            time: '',
            Jiexi: '1'
		};
		this.LiIndex = 1;
		
		//console.log(this.state.testPaperId)
	}
	componentDidMount(props) {
		//测试详情
    	request(config.baseUrl+'api/Study/TP02?testPaperId='+this.state.testPaperId, "post").then(res=>{
            if(res && res.code == 0){
            	let Arr = [];
            	let index = 0;
            	let zongFen = 0;
            	res.data.forEach(item => {
            		item.questions.forEach(item2 => {
            			if(item2.Items){
            				item2.Items.item.forEach(item3=>{
	            				item3.checked = false;
	            			})
            			}else if(item2.Qus_Type == 3){
            				item2.checked = null;
            			}
            			index ++;
            			item2.index = index;
            			
            			zongFen += item2.Qus_Number;
            			
            			item2.json = {
	            			asw: '',
		            		flagg: false
	            		}
            		})
            		
            	})
            	this.setState({
            		TestData: res.data,
            		index: index,
            		zongFen: zongFen
            	});
            }
        });
        
        var myDate = new Date();
		var YY = myDate.getFullYear();    //获取完整的年份(4位,1970-????)
		var MM = myDate.getMonth();       //获取当前月份(0-11,0代表1月)
		var DD = myDate.getDate();        //获取当前日(1-31)
		var HH = myDate.getHours();       //获取当前小时数(0-23)
		var FF = myDate.getMinutes();     //获取当前分钟数(0-59)
		var SS = myDate.getSeconds();     //获取当前秒数(0-59)
		this.setState({
			time: YY + '-' +MM + '-' +DD + ' ' +HH + ':' +FF + ':' +SS
		})
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	OptionChecked(index, index2, numb, Type, index3){
		let TestData = this.state.TestData;
		if(Type == 3){
			TestData[index].questions[index2].checked = numb;
		}else if(Type == 1){
			TestData[index].questions[index2].Items.item.forEach(item=>{
            	item.checked = false;
        	})
			TestData[index].questions[index2].Items.item[index3].checked = !TestData[index].questions[index2].Items.item[index3].checked;
		}else if(Type == 2){
			TestData[index].questions[index2].Items.item[index3].checked = !TestData[index].questions[index2].Items.item[index3].checked;
		}
		this.setState({
    		TestData: TestData
    })
	}
	SetSubmit(nub){
		let index = this.state.index;
		if(nub == 0){
			this.setState({
				subFlag: false
			})
			if(this.LiIndex == 1){
				return
			}
			this.LiIndex --;
		}else{
			this.LiIndex ++;
			if(this.LiIndex >= index){
				this.setState({
					subFlag: true
				})
				this.LiIndex = index;
			}
			
		}
	}
	submit(){
        Modal.alert('提示', '确认要提交吗？提交后不可更改！', [
            { text: '取消', onPress: () => {}, style: 'default' },
            { text: '确认', onPress: () => {
            		let data = {
						  "testPaperId": this.state.testPaperId,
						  "answers": []
						};
					let TestData = this.state.TestData;
					TestData.forEach(item => {
	            		item.questions.forEach(item2 => {
	            			let as = [];
	            			let flag = true;
	            			if(item2.Qus_Type == 1){
	            				item2.Items.item.forEach((item3,index3)=>{
		            				if(item3.checked){
		            					data.answers.push({
									      	"questionId": item2.Qus_ID,
									      	"answer": ''+item3.Ans_ID,
									      	"score": item2.Qus_Number
		            					});
		            				}
		            				if(item3.Ans_IsCorrect){
		            					as.push(this.state.letterArr[index3]);
		            				}
		            				if(flag && item3.Ans_IsCorrect !== item3.checked){
		            					flag = false;
		            				}
		            			})
	            			}else if(item2.Qus_Type == 2){
	            				let Ans_IDARR = [];
	            				item2.Items.item.forEach((item3,index3)=>{
		            				if(item3.checked){
		            					Ans_IDARR.push(item3.Ans_ID);
		            				}
		            				if(item3.Ans_IsCorrect){
		            					as.push(this.state.letterArr[index3]);
		            				}
		            				if(flag && item3.Ans_IsCorrect !== item3.checked){
		            					flag = false;
		            				}
		            			})
	            				data.answers.push({
							      	"questionId": item2.Qus_ID,
							      	"answer": Ans_IDARR.join(','),
							      	"score": item2.Qus_Number
            					})
	            			}else if(item2.Qus_Type == 3){
	            				let trag = null;
	            				data.answers.push({
							      	"questionId": item2.Qus_ID,
							      	"answer": item2.checked == 0?'true':item2.checked == 1?'false':'',
								    "score": item2.Qus_Number
            					})
	            				if(item2.checked == 0){
	            					trag = true;
	            				}else if(item2.checked == 1){
	            					trag = false;
	            				}
		            			item2.Items.item.forEach((item3,index3)=>{
		            				if(trag !== item3.Ans_IsCorrect){
		            					flag = false;
		            				}
		            				if(item3.Ans_IsCorrect){
		            					as.push(this.state.letterArr[0]);
		            				}else{
		            					as.push(this.state.letterArr[1]);
		            				}
		            			})
	            			}
	            			item2.json = {
	            				asw: as.join('，'),
	            				flagg: flag
	            			}
	            		})
	            	})
					let that = this;
					request(config.baseUrl+'api/Study/TP03', "post", data).then(res=>{
			            Toast.info(res.message, 1.5);
			            if(res.code == 0){
			            	setTimeout(function(){
			            		that.setState({
				            		score: res.data,
				            		scoreFlag: true,
				            		TestData2: TestData
				            	})
			            	},1500)
			            	document.body.scrollTop = 0;
							document.documentElement.scrollTop = 0;
			            }
			        });
                }
            }
        ]);
	}
	JiexiTitle(index){
		let data = this.state.TestData;
		let Arr = [];
		if(index == '2'){
			data.forEach(item => {
				let Arr2 = [];
	    		item.questions.forEach(item2 => {
	    			if(!item2.json.flagg){
	    				Arr2.push(item2);
	    			}
	    		})
	    		if(Arr2.length>0){
	    			Arr.push({
						paperItem: item.paperItem,
						questions: Arr2
					})
	    		}
	    	})
		}else{
			Arr = data;
		}
		this.setState({
			Jiexi: index,
			TestData2: Arr
		})
	}
	render() {
		return(
			<div>
				<SubHeaderComponent title="测一测"></SubHeaderComponent>
				<div className={this.state.scoreFlag?'hide':'test'}>
					<div className={this.state.TestData.length>0?'hide':'heji'}>暂无考试内容</div>
					<div className={this.state.TestData.length>0?'heji':'hide'}>共{this.state.index}题，合计{this.state.zongFen}分</div>
					<div className={'test-type'}>
						<ul className={'test-type-content'}>
						{
							this.state.TestData &&
							this.state.TestData.map((item,index)=>{
								return item.questions.map((item2,index2)=>{
									if(item2.Qus_Type === 3){
			            				//判断题
			            				return(
			            					<li key={index2}>
												<div className={'content-title'}>{item2.index}. {item2.Qus_Title}</div>
												<div className={'test-type-title'}>
													【判断题】 {item2.Qus_Number}分
												</div>
												<div className={"content-options"} onClick={this.OptionChecked.bind(this,index, index2, 0, item2.Qus_Type)}>
													<span>
														<img src={item2.checked == 0?require('../../../assets/images/video/raduschk.png'):require('../../../assets/images/video/radus.png')} alt='图片' />
													</span> A 正确
												</div>
												<div className={"content-options"} onClick={this.OptionChecked.bind(this,index, index2, 1, item2.Qus_Type)}>
													<span>
														<img src={item2.checked == 1?require('../../../assets/images/video/raduschk.png'):require('../../../assets/images/video/radus.png')} alt='图片' />
													</span> B 错误
												</div>
											</li>
			            				)
			            			}else if(item.paperItem.TPI_Type == 1){
			            				return(
			            					<li key={index2}>
												<div className={'content-title'}>{item2.index}. {item2.Qus_Title}</div>
												<div className={'test-type-title'}>
													【单项选择题】 {item2.Qus_Number}分
												</div>
												{
													item2.Items.item.map((item3,index3) => {
														return(
															<div className={item3.checked?"content-options active":"content-options"} onClick={this.OptionChecked.bind(this,index, index2, 0, item2.Qus_Type, index3)} key={index3}>
																<span>
																	<img src={item3.checked?require('../../../assets/images/video/raduschk.png'):require('../../../assets/images/video/radus.png')} alt='图片' />
																</span>
																{this.state.letterArr[index3]} {item3.Ans_Context}
															</div>
														)
													})
												}
											</li>
			            				)
			            			}else if(item.paperItem.TPI_Type == 2){
			            				return(
			            					<li key={index2}>
												<div className={'content-title'}>{item2.index}. {item2.Qus_Title}</div>
												<div className={'test-type-title'}>
													【多项选择题】 {item2.Qus_Number}分
												</div>
												{
													item2.Items.item.map((item3,index3) => {
														return(
															<div className={item3.checked?"content-options active":"content-options"} onClick={this.OptionChecked.bind(this,index, index2, 0, item2.Qus_Type, index3)} key={index3}>
																<span>
																	<img src={item3.checked?require('../../../assets/images/video/chk2.png'):require('../../../assets/images/video/chk.png')} alt='图片' />
																</span>
																{this.state.letterArr[index3]} {item3.Ans_Context}
															</div>
														)
													})
												}
											</li>
			            				)
			            			}
								})
							})
						}
						</ul>
					</div>
					<div className={this.state.TestData.length >= 0?'hide':'test-direction'}>
					{
//						<div className={'swiper-prev'} onClick={this.SetSubmit.bind(this,0)}>
//							<img src={require('../../../assets/images/video/left.svg')} />
//						</div>
//						<div className={this.state.subFlag?'hide':'swiper-next'} onClick={this.SetSubmit.bind(this,1)}>
//							<img src={require('../../../assets/images/video/right.svg')} />
//						</div>
//						 className={this.state.subFlag?"submit":'submit hide'}
					}
						
						<div onClick={this.submit.bind(this)} className={this.state.testPaperId?'':'hide'}>
							提 交
						</div>
					</div>
				</div>
				<div className={this.state.scoreFlag?'':'hide'}>
					<div className={'test-defen'}>
						<div className={'test-type-content-im'}>
							<img src={require('../../../assets/images/video/fen.png')} />
						</div>
						<ul className={'test-type-content'}>
							<li className={'li-score'}>
								<div className={'head'}>
			                        <img src={this.state.sHead} alt={this.state.sNickname}/>
			                    </div>
								<div className={'test-type-score'}>
									<span>{this.state.score}</span> 分
								</div>
								<div className={'test-type-title'}>
									恭喜您完成本次考试
									<p>{this.state.time}</p>
								</div>
								<div className={'test-foot-btn'}>
									<div>查看证书</div>
									<div>逛一逛</div>
								</div>
							</li>
						</ul>
					</div>
					<div className={'test-type TestJiexi'}>
						<div className={'TestJiexi_title'}>
							<div className={'JxDiv1'}>答题解析</div>
							<div className={'JxDiv2'}>
								<span className={this.state.Jiexi == '1'?'active':''} onClick={this.JiexiTitle.bind(this, '1')}>全部题目</span>
								<span className={this.state.Jiexi == '2'?'active':''} onClick={this.JiexiTitle.bind(this, '2')}>错题</span>
							</div>
						</div>
						<ul className={'test-type-content'}>
						{
							/*<img src={item2.Ans_IsCorrect?require('../../../assets/images/video/vid3.png'):''} alt='图片' className={"content-options-img"} />*/
							this.state.TestData2 &&
							this.state.TestData2.map((item,index)=>{
								return item.questions.map((item2,index2)=>{
									if(item2.Qus_Type === 3){
			            				//判断题
			            				return(
			            					<li key={index2}>
												<div className={'content-title'}>{item2.index}. {item2.Qus_Title}</div>
												<div className={'test-type-title'}>
													【判断题】 {item2.Qus_Number}分
												</div>
												<div className={"content-options"}>
													<span>
														<img className={'Simg'} src={item2.Items.item[0].Ans_IsCorrect?require('../../../assets/images/video/vid3.png'):require('../../../assets/images/video/vid4.png')} alt='图片' />
														<img src={item2.checked == 0?require('../../../assets/images/video/vid1.png'):require('../../../assets/images/video/radus.png')} alt='图片' />
													</span> A 正确
												</div>
												<div className={"content-options"}>
													<span>
														<img className={'Simg'} src={!item2.Items.item[0].Ans_IsCorrect?require('../../../assets/images/video/vid3.png'):require('../../../assets/images/video/vid4.png')} alt='图片' />
														<img src={item2.checked == 1?require('../../../assets/images/video/vid1.png'):require('../../../assets/images/video/radus.png')} alt='图片' />
													</span> B 错误
												</div>
												<div className={'test-type-as'}>
													<div>
														<span className={item2.json.flagg?'test-type-as-s active':'test-type-as-s'}>{item2.json.flagg?'回答正确':'回答错误'}</span>
														<span className={'test-type-as-s2'}> (得分：{item2.json.flagg?item2.Qus_Number:'0'}分)</span>
													</div>
													<div>
														正确答案：{item2.json.asw}
													</div>
													<div>
														解析：{item2.Qus_Explain !== ''?item2.Qus_Explain:'无'}
													</div>
												</div>
											</li>
			            				)
			            			}else if(item.paperItem.TPI_Type == 1){
			            				return(
			            					<li key={index2}>
												<div className={'content-title'}>{item2.index}. {item2.Qus_Title}</div>
												<div className={'test-type-title'}>
													【单项选择题】 {item2.Qus_Number}分
												</div>
												{
													item2.Items.item.map((item3,index3) => {
														return(
															<div className={item3.checked?"content-options active":"content-options"} key={index3}>
																<span>
																	<img className={'Simg'} src={item3.Ans_IsCorrect?require('../../../assets/images/video/vid3.png'):item3.Ans_IsCorrect != item3.checked?require('../../../assets/images/video/vid4.png'):require('../../../assets/images/video/vid5.png')} alt='图片' />
																	<img src={item3.checked?require('../../../assets/images/video/vid1.png'):require('../../../assets/images/video/radus.png')} alt='图片' />
																</span>
																{this.state.letterArr[index3]} {item3.Ans_Context}
															</div>
														)
													})
												}
												<div className={'test-type-as'}>
													<div>
														<span className={item2.json.flagg?'test-type-as-s active':'test-type-as-s'}>{item2.json.flagg?'回答正确':'回答错误'}</span>
														<span className={'test-type-as-s2'}> (得分：{item2.json.flagg?item2.Qus_Number:'0'}分)</span>
													</div>
													<div>
														正确答案：{item2.json.asw}
													</div>
													<div>
														解析：{item2.Qus_Explain !== ''?item2.Qus_Explain:'无'}
													</div>
												</div>
											</li>
			            				)
			            			}else if(item.paperItem.TPI_Type == 2){
			            				return(
			            					<li key={index2}>
												<div className={'content-title'}>{item2.index}. {item2.Qus_Title}</div>
												<div className={'test-type-title'}>
													【多项选择题】 {item2.Qus_Number}分
												</div>
												{
													item2.Items.item.map((item3,index3) => {
														return(
															<React.Fragment key={index3}>
																<div className={item3.checked?"content-options active":"content-options"}>
																	<span>
																		<img className={'Simg'} src={item3.Ans_IsCorrect?require('../../../assets/images/video/vid3.png'):item3.Ans_IsCorrect != item3.checked?require('../../../assets/images/video/vid4.png'):require('../../../assets/images/video/vid5.png')} alt='图片' />
																		<img src={item3.checked?require('../../../assets/images/video/vid2.png'):require('../../../assets/images/video/chk.png')} alt='图片' />
																	</span>
																	{this.state.letterArr[index3]} {item3.Ans_Context}
																</div>
															</React.Fragment>
														)
													})
												}
												<div className={'test-type-as'}>
													<div>
														<span className={item2.json.flagg?'test-type-as-s active':'test-type-as-s'}>{item2.json.flagg?'回答正确':'回答错误'}</span>
														<span className={'test-type-as-s2'}> (得分：{item2.json.flagg?item2.Qus_Number:'0'}分)</span>
													</div>
													<div>
														正确答案：{item2.json.asw}
													</div>
													<div>
														解析：{item2.Qus_Explain !== ''?item2.Qus_Explain:'无'}
													</div>
												</div>
											</li>
			            				)
			            			}
								})
							})
						}
						</ul>
					</div>
				</div>
		    </div>
		);
	}
}